export default __webpack_public_path__ + "static/media/Seinye.06878246.png";